/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import UsersTable from './UsersTable';

export default function Users() {
    return (
        <div className="flex flex-col mt-10">
            <UsersTable />
        </div>
    );
}
